import React from 'react'

const AddIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.49703 3.5C5.96703 3.5 4.33203 5.233 4.33203 7.916V16.084C4.33203 18.767 5.96703 20.5 8.49703 20.5H17.165C19.696 20.5 21.332 18.767 21.332 16.084V7.916C21.332 5.233 19.696 3.5 17.166 3.5H8.49703ZM17.165 22H8.49703C5.10803 22 2.83203 19.622 2.83203 16.084V7.916C2.83203 4.378 5.10803 2 8.49703 2H17.166C20.555 2 22.832 4.378 22.832 7.916V16.084C22.832 19.622 20.555 22 17.165 22Z"
        fill="#273754"
      />
      <path
        d="M7.83203 12H17.832"
        stroke="#004360"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M12.832 17V7"
        stroke="#004360"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  )
}

export default AddIcon
